import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'countup.js-angular2';
import { CountUpComponent } from './count-up.component';
import { CanvasCircleChartComponent } from './canvas-circle-chart/canvas-circle-chart.component';

@NgModule({
    imports: [
        CommonModule,
        CountUpModule
    ],
    declarations: [CountUpComponent, CanvasCircleChartComponent],
    exports: [CountUpModule, CountUpComponent, CanvasCircleChartComponent]
})
export class CustomCountUpModule {
}
